export default __webpack_public_path__ + "static/media/i237hk.447ed009.webp";